<template>
  <div
    v-if="!canInteract"
    class="z-top row justify-center q-loading__indicator"
  >
    <q-spinner-puff
      color="primary"
      size="14em"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'LoadingIndicator',
  computed: {
    ...mapState('application', ['canInteract']),
  },
};
</script>
